export class CertificationCommand {
    name: string;
    provider?: {
        id: string;
    };
    validity_period?: number;
    has_expiration_date?: boolean;
    certificate_target_count?: number;

    constructor(name: string, providerId?: string, validityPeriod?: number, hasExpirationDate?: boolean, targetCount?: number) {
        this.name = name;
        if (providerId) {
            this.provider = {
                id: providerId,
            };
        }
        this.validity_period = validityPeriod;
        this.has_expiration_date = hasExpirationDate;
        this.certificate_target_count = targetCount;
    }
}
